// Thin Mixpanel wrapper.
// Initialization is handled by the official CDN snippet in /public/index.html
// (full token + EU api_host + autocapture + session replay).
// We do NOT call mixpanel.init() from here to avoid double-init / token override.
// The snippet exposes `window.mixpanel` as a stub that queues calls until the
// real lib loads, so calling track() before the lib is ready is safe.

const _mp = () => (typeof window !== 'undefined' ? window.mixpanel : null);

// Kept as a no-op for backward compatibility with existing imports (App.js).
export const initAnalytics = () => {};

// Track an event. Safe to call before the CDN lib is fully loaded — the stub buffers calls.
export const track = (eventName, properties = {}) => {
  const mp = _mp();
  if (!mp || typeof mp.track !== 'function') return;
  try {
    mp.track(eventName, properties);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`[analytics] track(${eventName}) failed`, e);
  }
};

// Tie subsequent events to a known user_id (after login/signup).
export const identifyUser = (userId, traits = {}) => {
  const mp = _mp();
  if (!mp || typeof mp.identify !== 'function') return;
  try {
    mp.identify(userId);
    if (mp.people?.set && Object.keys(traits).length) {
      mp.people.set(traits);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[analytics] identify failed', e);
  }
};

export const resetAnalytics = () => {
  const mp = _mp();
  if (!mp || typeof mp.reset !== 'function') return;
  try { mp.reset(); } catch (_) { /* ignore */ }
};
